module.exports = __webpack_public_path__ + "img/frejaId.da5ba4f9.png";